module.exports = __webpack_public_path__ + "img/placeholder.59e6f5b8.jpg";